import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import MultiDemands from '@components/pages/admin/carriers/MultiDemands';
import { useTranslation } from 'react-i18next';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const MultiDemandPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t('MultiDemandPage.multiDemands', ' MultiDemands')}>
      {/*// @ts-ignore*/}

      <Card>
        <MultiDemands />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(MultiDemandPage);
